import { portalApi } from '@/lib/http/axios';

export interface SubsidiaryFilterPreference {
    orgIds: number[];
    savedOrgIds?: number[];
    cleanedDuringRead?: boolean;
}

export const userPreferenceService = {
    getSubsidiaryFilter: () =>
        portalApi.get<SubsidiaryFilterPreference>('/users/me/preferences/subsidiary-filter'),

    setSubsidiaryFilter: (orgIds: number[]) =>
        portalApi.put<SubsidiaryFilterPreference>('/users/me/preferences/subsidiary-filter', {
            orgIds,
        }),
};
